import { ValidationErrors } from "@angular/forms";

export class ErrorMessage {
  getErrorMessage(error: unknown): string {
    if (!this.isErrorRecord(error)) {
      return this.getServerErrorMessage(error);
    }

    const errorKey = Object.keys(error)[0];
    switch (errorKey) {
      case "required":
        return "VALIDATOR.REQUIRED";
      case "minlength":
        return (
          "จำนวนตัวอักษรขั้นต่ำ " +
          this.getRequiredLength(error["minlength"]) +
          " ตัวอักษร"
        );
      case "maxlength":
        return (
          "จำนวนตัวอักษรไม่เกิน " +
          this.getRequiredLength(error["maxlength"]) +
          " ตัวอักษร"
        );
      case "email":
        return "VALIDATOR.EMAIL";
      case "mustMatch":
        return "VALIDATOR.MUST_MATCH";
      case "thaiNationalID":
        return "VALIDATOR.THAI_NATION_ID";
      default:
        return this.getServerErrorMessage(error);
    }
  }

  getServerErrorMessage(value: unknown): string {
    if (Array.isArray(value)) {
      const error = this.getErrorMessage(value[0]);
      return error;
    }

    if (typeof value === "string") {
      return value;
    }

    if (value == null) {
      return "";
    }

    return "";
  }

  private isErrorRecord(value: unknown): value is ValidationErrors {
    return typeof value === "object" &&
      value !== null &&
      !Array.isArray(value) &&
      Object.keys(value).length > 0;
  }

  private getRequiredLength(value: unknown): string {
    if (
      typeof value === "object" &&
      value !== null &&
      "requiredLength" in value
    ) {
      return String(value.requiredLength);
    }

    return "";
  }
}
